import { __assign, __awaiter, __generator } from "tslib";
import request from './request';
function getBoundCards(data) {
    var methods = data.payment_methods;
    return Object.keys(methods)
        .filter(function (id) { return id.startsWith('card'); })
        .map(function (id) { return (__assign(__assign({}, methods[id]), { 'method_id': methods[id].id, id: id })); });
}
export default function loadBoundCards(apiHost, serviceToken) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, request({
                        method: 'GET',
                        url: apiHost + "/web/payment_methods",
                        headers: serviceToken ? { 'X-Service-Token': serviceToken } : undefined
                    })];
                case 1:
                    data = _a.sent();
                    return [2, getBoundCards(data)];
            }
        });
    });
}
